import Dialogue from 'components/game/module/engines/dialogue/dialogue';
import Feedback from 'components/ui/feedback/feedback';

const taskTemplates = require('data/templates/task-templates');
const {effectTemplate} = require('data/templates/effect-template');

let moduleTasks = [
	Object.assign({}, taskTemplates.instructionsTemplate.mainTemplate, {
		taskId: 's1-m1-instructions-intro',
		background: 'home',
		backgroundModifier: 'bedroom',
		text: {
			da: `Hej og velkommen til Vikarkøreprøven, jeg er din vikarmentor og skal hjælpe dig igennem dagen.`,
			en: ``,
		}
	}),
	Object.assign({}, taskTemplates.instructionsTemplate.mainTemplate, {
		taskId: 's1-m1-instructions-stars',
		background: 'home',
		backgroundModifier: 'bedroom',
		text: {
			da: `Du vil i løbet af dagen blive stillet over for opgaver og situationer hvor du skal applicere det du har lært i kurset på begivenheder inspireret af virkeligheden. For at bestå dagen skal du have 3 stjerner.`,
			en: ``,
		}
	}),
	Object.assign({}, taskTemplates.dialogueTemplate.mainTemplate, {
		taskId: 's1-m1-dialogue-secretary',
		background: 'home',
		backgroundModifier: 'bedroom',
		layout: 's1-m1-secretary',
		maxPoints: 3,
		characterId: 'secretary',
		image: 'secretary-calling',
		text: {
			da: `Din telefon ringer klokken 7:30. 
				<br />Det er vikardækkeren:`
		},
		steps: [
			Object.assign({}, taskTemplates.dialogueTemplate.stepTemplate, {
				id: 'step-1',
				text: {
					da: `Godmorgen! Vi mangler en vikar fra 1. lektion til 6. lektion  i dag. Kan du være på skolen om en halv time?`
				},
				options: [
					Object.assign({}, taskTemplates.dialogueTemplate.stepOptionTemplate, {
						id: 'option-1',
						text: {
							da: `Selvfølgelig, Ved du om der ligger vikarnoter til mine timer?`
						},
						nextStepId: 'step-3',
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 3
							}),
						]
					}),
					Object.assign({}, taskTemplates.dialogueTemplate.stepOptionTemplate, {
						id: 'option-2',
						text: {
							da: `Ja, det kan jeg sagtens - Ved du hvilke klasser og fag jeg skal have?`
						},
						nextStepId: 'step-2',
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 3
							}),
						]
					}),
					Object.assign({}, taskTemplates.dialogueTemplate.stepTemplate, {
						id: 'option-3',
						text: {
							da: `Naturligvis, jeg skynder mig at gøre mig klar`
						},
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 2
							}),
						],
						nextStepId: 'step-5'
					})
				]
			}),
			Object.assign({}, taskTemplates.dialogueTemplate.stepTemplate, {
				id: 'step-2',
				text: {
					da: `Ja, du skal have 2.C til historie om Columbus her til morgen, og så har du 3.C til matematik og så 8.A sidst på dagen`
				},
				nextStepId: 'step-4'
			}),
			Object.assign({}, taskTemplates.dialogueTemplate.stepTemplate, {
				id: 'step-3',
				text: {
					da: `Der er vikarnoter i Aula. Du følger bare skemaet - der ligger materiale klar i dueslaget når du kommer.`
				},
				nextStepId: 'step-6'
			}),
			Object.assign({}, taskTemplates.dialogueTemplate.stepTemplate, {
				id: 'step-4',
				type: 'action',
				text: {
					da: `Du skynder dig at gøre dig klar til dagen og tager afsted.`
				}
			}),
			Object.assign({}, taskTemplates.dialogueTemplate.stepTemplate, {
				id: 'step-5',
				text: {
					da: `Det lyder godt, vi ses!`
				},
				nextStepId: 'step-4'
			}),
			Object.assign({}, taskTemplates.dialogueTemplate.stepTemplate, {
				id: 'step-6',
				type: 'action',
				text: {
					da: `Du tjekker skema og vikarnoter i Aula, inden du tager afsted.`
				}
			}),
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		taskId: 's1-m1-mc-introduction-thoughts',
		background: 'home',
		backgroundModifier: 'park-out',
		isDilemma: true,
		maxPoints: 3,
		text: {
			da: `Mens du cykler, overvejer du hvordan du vil starte første time.`,
			en: ``,
		},
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: {
					da: `Du fortæller 3 relaterbare fun facts om dig selv`,
					en: ``
				},
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'points',
						value: 3
					}),
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `God idé! Relaterbare facts om dig selv er en god måde at skabe en  forbindelse til eleverne.`,
								en: ``,
							}
						})
					})
				]
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: {
					da: `Du beder alle elever om at rate deres morgenhumør`,
					en: ``
				},
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'points',
						value: 3
					}),
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `Det er en god måde at starte dagen på, så eleverne kan lande og vise dig hvor klar de er til at starte dagen.`,
								en: ``,
							}
						})
					})
				]
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: {
					da: `Du spørger om der er elever med ordblindhed eller andre behov for hjælp i klassen`,
					en: ``
				},
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `At spørge så direkte ud i klassen, kan være grænseoverskridende for nogle elever.`,
								en: ``,
							}
						})
					})
				]
			}),
		]
	}),
	Object.assign({}, taskTemplates.dialogueTemplate.mainTemplate, {
		taskId: 's1-m1-dialogue-test',
		layout: 's1-m1-test',
		background: 'school',
		backgroundModifier: 'teachers-room-left',
		maxPoints: 3,
		characterId: 'test',
		image: 'shelf',
		text: {
			da: `Du kommer så du kan nå at hente opgaver i dueslaget og være i klassen i god tid til at modtage eleverne. Du finder dueslaget til 2.C, men det er tomt.
				<br />En lærer der står i nærheden siger:`
		},
		steps: [
			Object.assign({}, taskTemplates.dialogueTemplate.stepTemplate, {
				id: 'step-1',
				text: {
					da: `Nå, skal du have 2.C i dag? Jeg har ikke selv klassen, men du er altid velkommen til at spørge om hjælp.`
				},
				options: [
					Object.assign({}, taskTemplates.dialogueTemplate.stepOptionTemplate, {
						id: 'option-1',
						text: {
							da: `Undskyld, ved du hvor opgaverne ellers kunne ligge?`
						},
						nextStepId: 'step-2',
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 3
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: `Det er godt du spørger til opgaverne. Det er vigtigt at være godt forberedt inden timen starter.`,
										en: ``,
									}
								})
							}),
						]
					}),
					Object.assign({}, taskTemplates.dialogueTemplate.stepOptionTemplate, {
						id: 'option-2',
						text: {
							da: `Hvilke lærere kender klassen godt?`
						},
						nextStepId: 'step-3',
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 2
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: `Det er ikke sikkert at du kan nå at få fat på Peter inden timen starter, men det er godt at du ved hvem der kan hjælpe/kender klassen godt.`,
									}
								})
							}),
						]
					}),
					Object.assign({}, taskTemplates.dialogueTemplate.stepOptionTemplate, {
						id: 'option-3',
						text: {
							da: `Tak for det - jeg finder på noget selv.`
						},
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 1
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: `Det er fint at du finder på noget selv, men det havde været bedre, hvis du havde lærerens opgaver til klassen.`,
									}
								})
							}),
						]
					})
				]
			}),
			Object.assign({}, taskTemplates.dialogueTemplate.stepTemplate, {
				id: 'step-2',
				text: {
					da: `Nogle lærere lægger opgaverne i klassen. Har du tjekket vikarnoter I Aula?`
				},
			}),
			Object.assign({}, taskTemplates.dialogueTemplate.stepTemplate, {
				id: 'step-3',
				text: {
					da: `Marianne er deres klasselærer, men hun er syg i dag. Peter har dem i matematik.`
				},
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		taskId: 's1-m1-mc-printer-problems',
		background: 'school',
		backgroundModifier: 'teachers-room-left',
		image: 'printer',
		isDilemma: true,
		maxPoints: 3,
		text: {
			da: `Du har fundet historieopgaver på “Vikarland” og vil gerne kopiere en sjov historieaktivitet om Columbus til at slutte timen med. Men printeren virker ikke, og displayet viser en fejlkode. Der er 10 minutter til timen starter.`,
			en: ``,
		},
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: {
					da: `Jeg finder en bevægelsesaktivitet og en opgave der kan løses på smartboard som en fælles aktivitet`,
					en: ``
				},
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'points',
						value: 3
					}),
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `God brug af Opgavebanken på vikarland! At kunne omstille sig hurtigt og kreativt er en kernekompetence som vikar.`,
								en: ``,
							}
						})
					})
				]
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: {
					da: `Jeg prøver at fixe printeren`,
					en: ``
				},
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'points',
						value: 2
					}),
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `Det er godt at du er løsningsorienteret, men måske kunne du have brugt tiden bedre.`,
								en: ``,
							}
						})
					})
				]
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: {
					da: `Jeg finder en film på Netflix, der er lidt historisk`,
					en: ``
				},
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'points',
						value: 1
					}),
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `Det er ikke god undervisning at vise fiktionsfilm.`,
								en: ``,
							}
						})
					})
				]
			}),
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, { // TODO: format ok?
		taskId: 's1-m1-mc-walk-to-class',
		background: 'school',
		backgroundModifier: 'hall-kids',
		isDilemma: true,
		maxPoints: 3,
		text: {
			da: `Drengene står udenfor 4A's klasselokale og spørger, om du skal være deres vikar? Der er to elever der er i konflikt og deres lærer er ikke kommet.`,
			en: ``,
		},
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: {
					da: `Det er ikke din opgave, så du siger: "Nej, desværre ikke.” “Der kommer nok en anden lærer om lidt.” Og går videre.`,
					en: ``
				},
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'points',
						value: 1
					}),
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `Det er vigtigt at tjekke om der er styr på tingene. Du kan ikke gå ud fra at eleverne selv kan løse en konflikt, der er ved at eskalere og det er ikke sikkert, at der kommer en anden voksen som kan hjælpe.`,
								en: ``,
							}
						})
					})
				]
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: {
					da: `Du taler med de to elever og hjælper dem med at få løst deres konflikt, indtil der kommer en lærer og overtager klassen, før du går hen til din egen klasse`,
					en: ``
				},
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'points',
						value: 3
					}),
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `Godt at du hurtigt hjalp de to elever. Du bør altid gribe ind i en konflikt mellem elever, da situationen hurtigt kan udvikle sig.`,
								en: ``,
							}
						})
					})
				]
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: {
					da: `Du sender eleverne på kontoret for at hente hjælp og går videre til din egen klasse`,
					en: ``
				},
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'points',
						value: 2
					}),
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `Det er vigtigt at tjekke om der er styr på tingene. Det er ikke sikkert, at der kommer en anden voksen som kan hjælpe.`,
								en: ``,
							}
						})
					})
				]
			}),
		]
	}),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		taskId: 's1-m1-spot-errors-2c-issues',
		layout: 's1-m1-2c-issues',
		background: 'school',
		backgroundModifier: 'classroom-2c',
		text: {
			da: `Du er kommet senere til timen, end du havde planlagt, fordi du måtte hjælpe med en konflikt mellem to elever. Eleverne sidder allerede i klassen og venter på dig.<br /><br /><i>Dette er en spot issues opgave. Find to ting i lokalet du bør reagere på med det samme.</i>`,
			en: ``,
		},
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {
				id: 'sad',
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `Godt spottet! En ked elev kan påvirke både læring og klassens dynamik. Det er vigtigt at opdage og reagere på elever i mistrivsel.`,
								en: ``,
							}
						})
					})
				]
			}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {
				id: 'scissors',
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `Sikkerhed er vigtig. Selvom det kan virke som en lille ting, er det vigtigt at etablere sikre rammer fra start.`,
								en: ``,
							}
						})
					})
				]
			}),
		]
	}),
	Object.assign({}, taskTemplates.branchingStoryTemplate.mainTemplate, {
		taskId: 's1-m1-branch-2c-issues',
		background: 'school',
		backgroundModifier: 'classroom-2c',
		text: {
			da: `Du har spottet både eleven med saksen og eleven der ser ked ud af det. Hvad gør du?`,
			en: ``
		},
		maxPoints: 6,
		steps: [
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
				id: 'step-1',
				text: null,
				options: [
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 1, 
						text: {
							da: `Går hen til den græddende elev og siger: "Hej - jeg kan se du er ked af det. Vil du fortælle mig hvad der er sket?"`,
							en: ``
						},
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 3
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: `Ved at prioritere eleven der er ked af det, viser du at trivsel er vigtig.`,
										en: ``,
									}
								})
							})
						],
						nextStepId: 'step-2',
					}),
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 2, 
						text: {
							da: `Går hen til eleven med saksen og siger: "tak - skal vi ikke aftale at sakse kun er fremme når vi klipper?"`,
							en: ``
						},
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 5
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: 'Det er super vigtgt at få håndteret en situation hvor en elev kan komme til skade.',
									}
								})
							})
						],
						nextStepId: 'step-3',
					}),
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 3, 
						text: {
							da: `Du skaber ro i klassen ved at bede eleverne om at rette fokus mod dig: "Jeg vil gerne have, at I har fokus på mig, holder munden lukket og kroppen i ro. Så kan vi starte."`,
							en: ``
						},
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 3
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: 'Du skaber ro i klassen. Når alle er sat i gang, får du mulighed for at håndtere situationer med enkelte elever.',
									}
								})
							})
						],
					})
				]
			}),
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
				id: 'step-2',
				text: {
					da: `Eleven kigger op, tøver lidt.`,
					en: ``
				},
				options: [
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 1, 
						text: {
							da: `Jeg sætter mig stille ved siden af og venter.`,
							en: ``
						},
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 3
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: 'Godt håndteret! Du får sat en klar ramme uden at lægge for meget pres på.',
									}
								})
							})
						],
						nextStepId: 'step-5'
					}),
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 2,
						text: {
							da: `Jeg siger: "Skal vi gå lidt ud på gangen og snakke?"`,
							en: ``
						}, 
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 2
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: 'Du tager eleven seriøst, men måske kan fokus i plenum, være lidt svært når man er ked af det.',
									}
								})
							})
						],
						nextStepId: 'step-6'
					}),
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 3,
						text: {
							da: `Jeg siger: "Det er helt okay hvis du ikke vil snakke nu"`,
							en: ``
						}, 
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 1
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: 'Når en elev er ked af det er det bedste man kan gøre at skabe et rum for eleven kan fortælle hvad der er galt, uden at lægge for meget pres på. Men samtidigt  skal du også sætte en ramme for samtalen, og ikke åbne op for at man kan sidde og være ked af det uden at det bliver håndteret. Det ville være godt at resten af klassen var sat i gang med en aktivitet, så du har tid til at hjælpe en enkelt elev.',
									}
								})
							})
						],
						nextStepId: 'step-7'
					})
				]
			}),
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
				id: 'step-3',
				text: {
					da: `"Okay..." eleven lægger modvilligt saksen væk.`
				}
			}),
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
				id: 'step-5',
				text: {
					da: `"Det er bare... jeg ville have lavet gruppearbejde med Agnes, men nu sidder hun sammen med Karl Wilhelm i stedet..."`
				},
				options: [
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 1, 
						text: {
							da: `Nu forstår jeg hvorfor du er ked af det. Skal vi prøve at finde en god gruppe til dig?`,
							en: ``
						}, 
					})
				]
			}),
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
				id: 'step-6',
				text: {
					da: `"Nej tak... jeg vil hellere bare være her"`
				},
				options: [
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 1, 
						text: {
							da: `Det er helt okay. Jeg er her hvis du får lyst til at snakke`,
							en: ``
						}, 
					}),
				]
			}),
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
				id: 'step-7',
				text: {
					da: `Eleven nikker stille.`,
					en: ``
				}
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		taskId: 's1-m1-mc-position',
		background: 'school',
		backgroundModifier: 'classroom-2c',
		isDilemma: true,
		maxPoints: 3,
		text: {
			da: `Nu er det tid til at starte timen rigtigt. Hvordan vælger du at placere dig?`,
			en: ``,
		},
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: {
					da: `Placerer dig centralt i rummet med rank ryg, bevæger dig roligt rundt mellem grupperne mens du fortæller`,
					en: ``
				},
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'points',
						value: 3
					}),
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `Du kombinerer højstatus kropssprog med nærvær og tilgængelighed. Ved at bevæge dig rundt skaber du både overblik og relation til alle elever.`,
								en: ``,
							}
						})
					})
				],
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: {
					da: `Bliver stående ved smartboardet mens du tegner og forklarer`,
					en: ``
				},
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'points',
						value: 2
					}),
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `Du har godt overblik over klassen, men mister lidt af nærheden.`,
								en: ``,
							}
						})
					})
				],
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: {
					da: `Sætter dig på en stol ved et af bordene for at være i øjenhøjde med eleverne`,
					en: ``
				},
				effects: [
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'points',
						value: 1
					}),
					Object.assign({}, effectTemplate.mainTemplate, {
						type: 'feedback',
						feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
							text: {
								da: `Du skaber god kontakt med nogle elever, men mister overblikket over resten af klassen.`,
								en: ``,
							}
						})
					})
				],
			}),
		]
	}),
	Object.assign({}, taskTemplates.branchingStoryTemplate.mainTemplate, {
		taskId: 's1-m1-branch-2c-columbus',
		background: 'school',
		backgroundModifier: 'classroom-2c',
		text: {
			da: `Du fortæller klassen, at dagens historietime skal handle om Christopher Columbus. En elev bagerst i klassen udbryder pludselig: "Det lyder MEGA kedeligt!"
				<br />Hvad siger du?`
		},
		maxPoints: 6,
		steps: [
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
				id: 'step-1',
				text: null,
				options: [
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 1, 
						text: {
							da: `Ved I hvad? Columbus troede faktisk han sejlede til et helt andet sted. Skal vi høre hvordan det gik galt?`
						},
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 3
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								Feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: 'Godt vinklet! Du skaber interesse ved at tage fat på emnet.',
									}
								})
							})
						],
						nextStepId: 'step-2',
					}),
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 2, 
						text: {
							da: `Hvorfor synes du det lyder kedeligt?`
						},
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 2
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								Feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: 'God idé at spørge ind til følelsen.',
									}
								})
							})
						],
						nextStepId: 'step-3',
					}),
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 3, 
						text: {
							da: `I bliver nødt til at høre efter, ellers ødelægger i det for resten af klassen`
						},
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 1
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								Feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: 'Det kan godt være det vil virke med den lidt hårde tilgang, men som regel vil det give dårlig stemning og ikke skabe lyst til at høre mere om emnet.',
									}
								})
							})
						],
						nextStepId: 'step-4',
					})
				]
			}),
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
				id: 'step-2',
				text: {
					da: `Andre elever begynder at se interesserede ud`
				},
				options: [
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 1, 
						text: {
							da: `Fortsætter engageret: "Forestil jer at I skal sejle et sted hen hvor ingen har været før..."`
						},
						nextStepId: 'step-5'
					}),
				]
			}),
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
				id: 'step-3',
				text: {
					da: `"Det er bare sådan noget gammelt noget... Det betyder ikke noget i dag".`
				},
				options: [
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 1, 
						text: {
							da: `Skal vi se på hvordan Columbus' rejse faktisk påvirker verden den dag i dag?`,
						},
						nextStepId: 'step-6'
					}),
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 2, 
						text: {
							da: `Ved I hvad der skete da han mødte de første mennesker i Amerika?`,
						},
						nextStepId: 'step-6'
					}),
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 3, 
						text: {
							da: `Lad os prøve at forestille os hvordan det var at sejle ud i det ukendte, har nogen af jer prøvet at rejse langt væk?`,
						},
						nextStepId: 'step-6'
					}),
				]
			}),
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
				id: 'step-4',
				text: {
					da: `Klassen sukker kollektivt`
				},
				options: [
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 1, 
						text: {
							da: `Du prøver at fortælle en røverhistorie for at redde dig ud af den dårlige stemning.`,
						},
						nextStepId: 'step-6'
					})
				]
			}),
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
				id: 'step-5',
				text: {
					da: `Nu har du fanget klassens opmærksomhed, men en elev afbryder: 'Døde der nogen på rejsen?'`
				},
				options: [
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 1, 
						text: {
							da: `Det er faktisk et rigtig godt spørgsmål - er der nogen der ved det?`,
						},
						nextStepId: 'step-6' 
					}),
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 2, 
						text: {
							da: `Vi kommer til det - men først skal I høre om hvordan man overhovedet finder vej på havet`,
						},
						nextStepId: 'step-6' 
					}),
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 3, 
						text: {
							da: `Ja, og det er en vigtig del af historien som vi skal høre om`,
						},
						nextStepId: 'step-6' 
					})
				]
			}),
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
				id: 'step-6',
				text: {
					da: `På trods af din indsats for det modsatte, er der uro der spreder sig i klassen. Du prøver at undervise om Columbus og hans opdagelser, men en lille gruppe, der sidder tæt på hinanden, bliver ved med at afbryde og komme med sjove kommentarer. Hvad gør du?`
				},
				options: [
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 1, 
						text: {
							da: `Jeg flytter en eller flere af eleverne, så de ikke sidder tæt sammen`
						}, 
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 2
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: `God idé. Nogle gange kan det hjælpe. Men der er selvfølgelig også en risiko for, at de bare råber til hinanden på tværs af klassen.`
									}
								})
							})
						]
					}),
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 2, 
						text: {
							da: `Jeg sætter dem til at løbe tre gange rundt ude i skolegården`,
						}, 
						nextStepId: 'step-7',
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 2
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: `Det kan være lige præcis det, de trænger til. Men husk at lave en klar aftale om hvor lang pause de har.`
									}
								})
							})
						]
					}),
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 3, 
						text: {
							da: `Jeg sender dem uden for døren`,
						}, 
						effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 1
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: `Hvis de forstyrrer meget, så kan det være nødvendigt. Men du risikerer, at du bare flytter problemet ud i fællesområdet, hvor andre klasser måske arbejder. `
									}
								})
							})
						]
					}),
					Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
						id: 4, 
						text: {
							da: `Jeg laver en lille fysisk leg om historie`,
						}, 
						Effects: [
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'points',
								value: 3
							}),
							Object.assign({}, effectTemplate.mainTemplate, {
								type: 'feedback',
								Feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
									text: {
										da: 'Det kan være en god idé at få kørt noget energi af.',
									}
								})
							})
						],
						nextStepId: 'step-8'
					}),
				]
			}),
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
				id: 'step-7',
				text: {
					da: `Efter lidt tid hører du, at der er gået leg i den udenfor, men da du kalder på dem, kommer de ind.`
				},
			}),
			Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
				id: 'step-8',
				text: {
					da: `Du havde heldigvis en aktivitet klar og efter den korte leg, er der mere ro på klassen.`
				},
			}),
		]
	}),
	Object.assign({}, taskTemplates.instructionsTemplate.mainTemplate, {
		taskId: 's1-m1-instructions-social-reflection',
		background: 'school',
		backgroundModifier: 'classroom-2c',
		text: {
			da: `Nu hvor du har håndteret nogle situationer i klassen, er det tid til en kort faglig refleksion.`
		}
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		taskId: 's1-m1-sort-relation-competence',
		text: {
			da: `Sortér disse handlinger i de rette kategorier - der behøver ikke være lige mange i hver kasse:`
		},
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 1,
				title: {
					da: `Understøtter trivsel`
				}
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 2,
				title: {
					da: `Kan skade trivsel`
				}
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 3,
				title: {
					da: `Neutral effect`
				}
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1,
				text: {
					da: `Diskret individuel kontakt`
				},
				categoryIds: [1]
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2,
				text: {
					da: `Offentlig irettesættelse`
				},
				categoryIds: [2]
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3,
				text: {
					da: `Fælles klassediskussion`
				},
				categoryIds: [1]
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4,
				text: {
					da: `Ignorere social eksklusion`
				},
				categoryIds: [2]
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5,
				text: {
					da: `Anerkende følelser`
				},
				categoryIds: [1]
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6,
				text: {
					da: `Tvinge grupper sammen`
				},
				categoryIds: [3]
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 7,
				text: {
					da: `Vente og observere`
				},
				categoryIds: [3]
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 8,
				text: {
					da: `Inddrage andre voksne`
				},
				categoryIds: [1]
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 9,
				text: {
					da: `Påpege problemer højlydt`
				},
				categoryIds: [1]
			}),
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		taskId: 's1-m1-sort-needs',
		text: {
			da: `Der er forskellige typer af motivation. Match typen med den rigtige beskrivelse.`
		},
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 1,
				title: {
					da: `Behov for selvbestemmelse`
				}
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 2,
				title: {
					da: `Behov for at opleve kompetence`
				}
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 3,
				title: {
					da: `Behov for samhørighed`
				}
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1,
				text: {
					da: `Må jeg selv vælge gruppe`
				},
				categoryIds: [1]
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2,
				text: {
					da: `Kan du se hvad jeg har lavet?`
				},
				categoryIds: [2]
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3,
				text: {
					da: `Vil du spise frokost med os?`
				},
				categoryIds: [3]
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4,
				text: {
					da: `Skal vi alle gøre det på samme måde?`
				},
				categoryIds: [1]
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5,
				text: {
					da: `Hvorfor tror du, det her ikke virker?`
				},
				categoryIds: [2]
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6,
				text: {
					da: `Hvem andre har valgt den her opgave?`
				},
				categoryIds: [3]
			})
		]
	}),
		Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
			taskId: 's1-m1-spot-errors-schoolyard-issues',
			layout: 's1-m1-schoolyard-issues',
			background: 'schoolyard',
			backgroundModifier: 'playground-issues',
			text: {
				da: `Find to ting i skolegården der kræver din særlige opmærksomhed.`
			},
			errors: [
				Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {
					id: 'boys',
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Godt spottet!De kunne godt se ud til at have nogle ideer om at lave ballade, så det er måske en god ide at holde ekstra øje med dem.`,
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {
					id: 'bench',
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Godt spottet! Selvom det kunne være gemmeleg, er det vigtigt at tjekke - især når eleven er alene.`
								}
							})
						})
					]
				}),
			]
		}),
		Object.assign({}, taskTemplates.branchingStoryTemplate.mainTemplate, {
			taskId: 's1-m1-bs-schoolyard-issues',
			background: 'schoolyard',
			backgroundModifier: 'playground-issues',
			text: {
				da: `Hvilken situation vil du undersøge først?`,
			},
			maxPoints: 3,
			steps: [
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-1',
					text: null,
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Går hen mod drengene der hvisker sammen`
							},
							nextStepId: 'step-2',
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Går hen mod eleven under bænken`
							},
							nextStepId: 'step-3',
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-2',
					text: {
						da: `Du nærmer dig drengene. Det viser sig at de har det vildt sjovt over en youtube video på en af drengenes telefoner. Du hjælper dem med at aflevere telefonen i klassen.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Du tjekker lige op på Eleven under bænken også`
							},
							nextStepId: 'step-3'
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-3',
					text: {
						da: `Da du nærmer dig, kan du se det er Emma fra 3.C. Hun ligger helt stille med lukkede øjne. Hun reagerer ikke på at du kommer nærmere.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Du tager fat i Emma for at se om hun er ved bevidsthed.`
							}, 
							nextStepId: 'step-4',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 2
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Du undersøger om Emma er ved bevidsthed. Det er bedst at kalde på hende først og hvis hun ikke reagerer, så tage fat i hende.`,
										}
									})
								})
							],
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Du kalder først normalt på Emma, så lidt højere: “Emma, er du okay? Er der sket noget?`
							}, 
							nextStepId: 'step-6',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Godt at du først forsøger at kalde på Emma! Det er vigtigt at finde ud af om du kan få kontakt til hende`,
										}
									})
								})
							],
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3, 
							text: {
								da: `Hej Emma, kan du rejse dig op? Kom herud, så vi kan snakke om hvad der er sket`
							}, 
							nextStepId: 'step-7',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Nå du siger det på den måde får du det til at lyde som om det er forkert at Emma sidder under bænken, og Emma vil derfor måske kunne føle sig mere forkert end hun allerede gør.`,
										}
									})
								})
							],
							
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-4',
					text: {
						da: `Emma fortæller at hun er faldet og har slået benet, der stadig gør meget ondt.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Kan du støtte på benet?`,
							}, 
							nextStepId: 'step-5'
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-5',
					text: {
						da: `"Det kan jeg godt, men det gør stadig ondt..."`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Du spørger om Emma kan gå, hvis du hjælper hende?`,
							}, 
							nextStepId: 'step-8'
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-6',
					text: {
						da: `Du trøster hende, mens hun grædende fortæller, at hun er faldet og har slået benet, der stadig gør meget ondt.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Du spørger om Emma kan gå, hvis du hjælper hende?`,
							}, 
							nextStepId: 'step-8'
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-7',
					text: {
						da: `Emma siger hun helst bare vil blive der. Efter lidt tid får du dog talt hende til ro og hun kommer ud og fortæller at hun blev holdt uden for af de andre, fordi de ikke gad lege dåseskjul, som er Emmas yndslingsleg.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Skal vi prøve at finde på nogle gode lege hvor alle kan være med?`,
							}, 
							nextStepId: 'step-8'
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-8',
					text: {
						da: `Du følger Emma på kontoret, hvor hun kan få undersøgt sit ben.`
					}
				})
			]
		}),
		Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
			taskId: 's1-m1-mc-cleaning-lady',
			background: 'school',
			backgroundModifier: 'hall-cleaning-lady',
			isDilemma: true,
			maxPoints: 3,
			text: {
				da: `På vej tilbage til klassen møder du skolens rengøringsdame Grethe, der med et stort smil husker dig på, at 3C skal have svømning i sidste time og at du meget gerne må hjælpe dem med at rydde op og sætte stole op, så der kan blive gjort rent?`
			},
			options: [
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 1,
					text: {
						da: `Selvfølgelig! Det skal jeg nok huske Grethe - og tak fordi du altid hjælper os med at passe på skolen!`
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'points',
							value: 3
						}),
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Du viser at alle på skolen er vigtige for fællesskabet - også overfor eleverne der kan høre samtalen.`
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 2,
					text: {
						da: `Det troede jeg ikke var min opgave?`
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'points',
							value: 1
						}),
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Du skal huske at der er mange opgaver, man skal løse som vikar. Det er vigtigt at du også hjælper med at tage ansvar for hele skolen.`
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 3,
					text: {
						da: `Ja, det klarer jeg. Sig til hvis der er andet vi skal huske. Du må have en fortsat god dag, Grethe!`
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'points',
							value: 3
						}),
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Du demonstrerer venlighed og professionalisme.`
								}
							})
						})
					]
				}),
			]
		}),
		Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
			taskId: 's1-m1-mc-pre-lunch',
			background: 'school',
			backgroundModifier: 'classroom-3c',
			isDilemma: true,
			maxPoints: 3,
			text: {
				da: `Der er flere elever, som fortsætter en konflikt fra frikvarteret. Det er noget med en fodboldkamp… de er meget højlydte og det lyder temmelig uklart, hvad der er sket.<br /><br />Hvordan vil du håndtere konflikten?`
			},
			options: [
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 1,
					text: {
						da: `Jeg “parkerer” konflikten og beder klassen starte matematiktimen i fokus. Jeg aftaler med klassen, hvordan næste frikvarter skal forløbe i slutningen af timen.`
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'points',
							value: 3
						}),
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `God ide at I ikke bruger for lang tid på en konflikt, der hører til i frikvarteret. Det er vigtigt at tage den op igen, som lovet inden næste frikvarter.`
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 2,
					text: {
						da: `Du løser konflikten med alle de involverede elever, inden du sætter klassen i gang med matematikopgaver`
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'points',
							value: 2
						}),
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Det kan være nødvendigt at hjælpe eleverne med at løse konflikter. Klassen kan let bruge meget lang tid på at snakke om en konflikt, uden at den bliver løst. Det giver ikke den bedste start på timen.`
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 3,
					text: {
						da: `Konflikten har ikke noget med timen at gøre, så jeg beder klassen om at stoppe, så vi kan starte med matematikopgaverne`
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'points',
							value: 1
						}),
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Det er svært at lægge en konflikt fra sig, hvis der ikke er udsigt til at løse den senere.`
								}
							})
						})
					]
				}),
			]
		}),
		Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
			taskId: 's1-m1-mc-math',
			background: 'school',
			backgroundModifier: 'classroom-3c',
			isDilemma: true,
			maxPoints: 3,
			text: {
				da: `Efter din håndtering af konflikten, husker du at præsentere dig for klassen, som du planlagde på cykelturen. Det giver en bedre stemning i klassen. Du sætter klassen i gang med at løse opgaver om plus og minus. Efter 5 minutter er Marcus allerede færdig, mens Sofia sidder fast ved den første opgave.`
			},
			options: [
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 1,
					text: {
						da: `Giver Marcus nogle sværere plusstykker og går hen for at hjælpe Sofia`
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'points',
							value: 3
						}),
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `God differentiering. Du udfordrer den stærke elev og støtter den elev der har brug for hjælp.`
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 2,
					text: {
						da: `Finder nogle hjælpemidler til Sofia og giver samtidig Marcus opgaver hvor han skal forklare sin tankegang`
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'points',
							value: 2
						}),
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Du giver både støtte og udfordring på et dybere niveau. At kunne forklare sin metode er en vigtig matematisk kompetence.`
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 3,
					text: {
						da: `Beder Marcus om at hjælpe Sofia, mens du hjælper andre`
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'points',
							value: 1
						}),
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Makkerhjælp kan være godt, men det er vigtigt at sikkert at begge elever er klar på det. Du skal nok holde lidt ekstra øje med hvordan det går.`
								}
							})
						})
					]
				}),
			]
		}),
		Object.assign({}, taskTemplates.branchingStoryTemplate.mainTemplate, {
			taskId: 's1-m1-bs-help-4c',
			background: 'school',
			backgroundModifier: 'classroom-3c-visit',
			text: {
				da: `En lærer kommer ind og fortæller at han er ressourcelærer, der skal hjælpe nogle elever med at bruge læse-skrive-teknologier. "Jeg har aftalt med klassens lærer, at jeg hentede dem i denne time.
					<br />Hvad svarer du?`,
			},
			steps: [
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-1',
					text: null,
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Selvfølgelig! Ved du hvilke elever, der skal med?`
							},
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `OK. Jeg spørger diskret og sender dem afsted om lidt.`
							},
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3, 
							text: {
								da: `Du spørger højt i klassen, hvem der skal have ressourcetimer?`
							},
							nextStepId: 'step-2',
							Effects: [
								Object.assign({}, taskTemplates.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Eleverne kan føle sig udstillet, når de skal sige det højt i klassen. Det var bedre at undersøge det mere diskret.`
										}
									})
								})
							]
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-2',
					text: {
						da: `Flere elever rækker modstræbende hånden op`
					}
				})
			]
		}),
		Object.assign({}, taskTemplates.branchingStoryTemplate.mainTemplate, {
			taskId: 's1-m1-bs-3c-lunch',
			background: 'school',
			backgroundModifier: 'classroom-3c-lunch',
			maxPoints: 3,
			text: {
				da: `Du bemærker at Victor ikke har nogen madpakke fremme. Han ser flov ud og prøver at være diskret omkring det.`,
			},
			steps: [
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-1',
					text: null,
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Går stille hen til Victor og hvisker.`
							},
							nextStepId: 'step-2',
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Spørger højt ud i klassen hvem der har ekstra mad med.`
							},
							nextStepId: 'step-4'
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3, 
							text: {
								da: `Lader som ingenting i første omgang.`
							},
							nextStepId: 'step-7'
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-2',
					text: {
						da: `Victor kigger væk da du nærmer dig.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Hej Victor, har du glemt madpakken i dag? Det sker for alle - skal vi se om vi kan finde en løsning?`
							},
							nextStepId: 'step-3',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Du håndterer situationen diskret og med omsorg. Du beskytter elevens værdighed mens du løser det praktiske problem.`
										}
									})
								})
							]
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-3',
					text: {
						da: `Du og Victor finder en løsning med kontoret, og han kan nu deltage i spisepausen med de andre.`
					}
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-4',
					text: {
						da: `Næsten alle hænder ryger op, og Victor begynder faktisk at smile lidt.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Det er så fint at I vil dele! Victor, vil du vælge hvem du vil dele med?`
							},
							nextStepId: 'step-5',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 2
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: 'God løsningsorientret tilgang. I nogle klasser kunne det dog godt have udviklet sig til et problem, hvis der ikke er en kultur hvor man altid hjælper hinanden.'
										}
									})
								})
							]
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-5',
					text: {
						da: `Nu vil alle gerne give Victor mad, og flere begynder at rejse sig.`
					}
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-6',
					text: {
						da: `Du får organiseret delingen så det foregår roligt, og Victor har nu mad til spisepausen.`
					}
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-7',
					text: {
						da: `Victor bliver mere og mere urolig på sin plads.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Victor, kan du lige hjælpe mig med noget ude på gangen?`
							},
							nextStepId: 'step-8',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1
								}),
							]
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-8',
					text: {
						da: `Du får diskret ordnet situationen med Victor ude på gangen, men han nåede at sidde et stykke tid og se fortabt ud, og nu har han meget travlt med at få spist.`
					}
				}),
			]
		}),
		Object.assign({}, taskTemplates.branchingStoryTemplate.mainTemplate, {
			taskId: 's1-m1-bs-3c-lunch-b',
			background: 'school',
			backgroundModifier: 'classroom-3c-lunch',
			maxPoints: 6,
			text: {
				da: `Mens klassen spiser, bemærker du at Maja, Liv og Clara hvisker sammen og kigger over mod Silje, som sidder alene og piller ved sin mad.
					<br />Hvad gør du?`,
			},
			steps: [
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-1',
					text: null,
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Sætter dig ved Siljes bord med din egen mad.`
							},
							nextStepId: 'step-2',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Går hen til de hviskende piger.`
							},
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 2
								})
							],
							nextStepId: 'step-4'
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3, 
							text: {
								da: `Hæver stemmen så alle kan høre.`
							},
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1
								})
							],
							nextStepId: 'step-6'
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-2',
					text: {
						da: `Silje kigger kort op men siger ikke noget. De andre piger hvisker stadig.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Jeg kan se du har gymnastiktaske med - går du til gymnastik?`
							},
							nextStepId: 'step-3'
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-3',
					text: {
						da: `Silje lyser op: 'Ja, jeg skal starte på holdet i dag!'`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Det lyder spændende! Er der andre fra klassen der går der?`
							},
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Det er godt at du får skabt en god samtale, der potentielt kan inkludere flere elever.`
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Det lyder sjovt! Skal du have særligt tøj på?`
							},
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Det er godt at du viser interesse for Siljes nye hobby.`
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3, 
							text: {
								da: `Fedt! Jeg gik også til gymnastik da jeg var barn`
							},
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Du skaber en personlig forbindelse gennem en fælles interesse.`
										}
									})
								})
							],
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-4',
					text: {
						da: `De bliver stille da du nærmer dig.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Det er så fint at I vil dele mad - men skal vi ikke sørge for at alle er med?`
							},
							nextStepId: 'step-5',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `At være så direkte i plenum, kan lede til at nogle elever taber ansigt og førre til at højne konfliktniveauet.`
										}
									})
								})
							]
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-5',
					text: {
						da: `Der kommer en lidt akavet stilhed og Silje sidder lidt og krymper sig. Efter lidt tid spørger en af pigerne om Silje ikke vil sidde med dem.
							<br /><br />Silje ser dog ikke super glad ud da de går ud til frikvarteret.`
					}
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-6',
					text: {
						da: `Nu skal vi have en hyggelig spisepause. Hvem vil fortælle om deres planer for eftermiddagen?`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Silje, jeg kan se du har gymnastiktøj med?`
							},
							nextStepId: 'step-7',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Når du sætter så meget fokus på en elev der i forvejen er udenfor, kan det både skabe rum for drillerier, og gøre eleven pinligt berørt.`
										}
									})
								})
							]
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-7',
					text: {
						da: `Silje bliver rød i hovedet over opmærksomheden og syens åbenlyst ikke det er særligt sjovt.
							<br /><br />På vej ud i gården til pausen, ser du, at hun finder sammen med nogen at lege med.`
					}
				})
			]
		}),
		Object.assign({}, taskTemplates.instructionsTemplate.mainTemplate, {
			taskId: 's1-m1-instructions-break',
			background: 'school',
			backgroundModifier: 'classroom-3c-lunch',
			text: {
				da: `Du tager en velfortjent pause oven på et par strabadserende timer. Tryk videre for at se din bedømmelse af første del.`,
			},
			textPassed: {
				da: `Du tager en velfortjent pause. Husk at bruge pausen på at lade op og være klar til næste time. Tryk videre for at se din bedømmelse af første del.`
			}
		})
];

let taskIdsArr = [];
moduleTasks.forEach((task, index) => {
	task.id = 's1-m1-' + (index + 1 < 10 ? '0' : '') + (index + 1);
	
	/* Check taskId is set when required and unique */
	if (task.isSolveToContinue) {
		if (task.taskId) {
			if (taskIdsArr.indexOf(task.taskId) >= 0) {
				console.error('Task id not unique: ', task.taskId);
			} else {
				taskIdsArr.push(task.taskId);
			}
		} else {
			console.error('Missing task id for task: ', task);
		}
	}
});


export {
	moduleTasks
};